const latestText = {
  en: {
    actu: "Latest & Upcoming",
    past: "Past events",
    events: [
      { text: "December 1, 2025: virtual reading and Q&A with Shira Abramovich and Alex Niemi, translators of Laura Vazquez, hosted by Type Books in Toronto"},
      { text: "September 21, 2025: panel on Collaborative Translation at Poetik Bazar Bruxelles",
        url: "https://www.poetikbazar.be/en/edition-2025/programme/rencontre-traduire-a-plusieurs-mains"
      },
      { text: "September 19, 2025: workshop on Queering Translation at Poetik Bazar Bruxelles",
        url: "https://www.poetikbazar.be/en/edition-2025/programme/atelier-queering-translation-pour-une-traduction-trans-poly-phonique"
      },
      { text: "May 29, 2025, 6pm: Montréal launch for The Hand of The Hand, Reading and Q&A with Shira Abramovich (Librairie L'Euguélionne, Montréal)"},
      { text: "May 3, 2025, 8pm: Reading with Shira Abramovich and Aiden Farrell (Molasses Books, Brooklyn)"},
      { text: "May 2, 2025, 7pm: Readings from The Hand of the Hand at Ugly Duckling Presse Spring Group Launch (The Old American Can Factory, Gowanus)",
        url: "https://shop.uglyducklingpresse.org/products/udp-spring-studio-party-macaisa-colgate-nissan-abramovich-schluter-ulmer-rees",
      },
      { text: "May 1, 2025: Publication of The Hand of the Hand, our translation of La Main de la main by Laura Vazquez, with Ugly Duckling Presse"},
      { text: "April 26, 2025: Mnémosyne, English-language event around poetic homage with Shira Abramovich, Lénaïg Cariou, Carrie Chappell and Alison Koehler, Rerenga Wine, Paris, 14h30" },
      { text: "April 25, 2025, 7pm: Event with Lénaïg Cariou, Shira Abramovich, and Charlotte Blanchard at L’Affranchie bookstore, Lille, France"},
      { text: "April 23, 2025, 7:30pm: event with Shira Abramovich, Lénaïg Cariou, Alex Lachkar and Jeanne Bacharach on The Dream of a Common Language in translation, Librairie La Friche, Paris" },
      { text: "March 15, 2025: Event around Adrienne Rich, with L'Arche (Médiathèque de Saint-Quentin-en-Yvelines)" },
      { text: "March 18, 2025: Workshop, \"Translating gender with Adrienne Rich\" (ENS de Lyon)" },
      { text: "March 6, 2025: Launch for Printemps Rayon Elegie by Kay Gabriel, with How to Become collective (Rerenga Wine, Paris)" },
      { text: "February 25, 2025: France Culture Book Club on Adrienne Rich" },
      { text: "February 2025: Publication of Printemps Rayon Elégie. Sonnets pour Candy., our translation of Elegy Department Spring: Candy Sonnets 1 by Kay Gabriel, with Éditions How to Become"},
      { text: "January 24, 2025: Reading event: \"Nos matrimoines : écrivaines états-uniennes\", Librairie les Modernes, Grenoble"},
      { text: "January 22, 2025: Event for Le Rêve d'un langage commun at the Université Grenoble Alpes library"},
      { text: "January 15, 2025: Publication of Le Rêve d'un langage commun, our translation of The Dream of a Common Language by Adrienne Rich, with L'Arche Éditeur"},
      {
        text: "Monday, November 6th: Workshop by Shira Abramovich at Simmons College"
      },
      {
        text: "Friday, October 13th: Reading with Laura Vazquez at Les Inaccoutumes festival, presented by La Ménagerie de Verre",
        url: "https://menageriedeverre.com/files/cp-inaccoutumes.pdf",
      },
      {
        text: "May 15, 2023: Workshop by Lénaïg Cariou at Centre Bloch Berlin on translating gender with Adrienne Rich",
        url: "https://cmb.hu-berlin.de/en/calendar/event/elise-huchet-forum-marc-bloch-politiques-de-la-traduction",
      },
      {
        text: "March 2023: Interview with Limited Connection Collective (fr)",
        url: "https://laviesansprincipe.wordpress.com/2023/03/08/interview-avec-le-collectif-connexion-limitee-limited-connection/",
      },
      {
        text: "Thursday, March 30th - Reading and Q&A with Eleni Sikelianos and Lénaïg Cariou at Festival Littérature au Centre, in Clermont-Ferrand",
      },
      {
        text: "Saturday, March 25th, 6:30pm - Reading by Eleni Sikelianos and her translators at Librairie EXC, in Paris",
      },
      {
        text: "Friday, January 27, 2023 - Book launch of Ce que j'ai connu, our translation of What I knew by Eleni Sikelianos, at L'Atelier, in Paris: reading and Q&A with the translators",
      },
      {
        text: "Fall 2022: Our translation of four poems by Laura Vazquez appear in the latest issue of Asymptote!",
        url: "https://www.asymptotejournal.com/poetry/the-hand-of-the-hand-laura-vazquez/",
      },
      {
        text: "March 19, 2022: Camille Blanc and Lénaïg Cariou read with Jean-François Puff and Sylvain Prudhomme at the Centre International de Poésie Marseille",
        url: "https://cipmarseille.fr/evenement_fiche.php?id=1459",
      },
      {
        text: 'April 7, 2021: Our very own Lénaïg Cariou is among the organizers of the conference "Femmes poètes, poètes femmes, poétesses… questions de terminologie" at the Séminaire de l’Université de Chicago',
        url: "https://poetesses.hypotheses.org/",
      },
      {
        text: "January 2021: Translation of Adrienne Rich's 'The Burning of Paper Instead of Children' appears in Revue Jef Klak",
        url: "https://www.jefklak.org/",
      },
      {
        text: "November 2020: Translation of Mónica de la Torre's '$6.82' appears in Revue Fragile",
        url: "https://fragile-revue.fr/la-lettre/6-82/",
      },
    ],
  },
  fr: {
    actu: "Actualité",
    past: "Évènements passés",
    events: [
      { text: "1 décembre, 2025 : lecture-rencontre virtuelle (animé par les libraires de Type Books à Toronto) avec Shira Abramovich et Alex Niemi, traductrices de Laura Vazquez"},
      { text: "21 séptembre 2025 : rencontre Traduire à plusieurs mains à Poetik Bazar Bruxelles",
        url: "https://www.poetikbazar.be/fr/edition-2025/programme/rencontre-traduire-a-plusieurs-mains"
      },
      { text: "19 séptembre 2025 : atelier Queering Translation à Poetik Bazar Bruxelles",
        url: "https://www.poetikbazar.be/fr/edition-2025/programme/atelier-queering-translation-pour-une-traduction-trans-poly-phonique"
      },
      { text: "29 mai, 2025, 18h: Lancement à Montréal pour The Hand of The Hand avec Shira Abramovich (Librairie L'Euguélionne, Montréal)"},
      { text: "3 mai 2025, 20h : Lecture avec Shira Abramovich et Aiden Farrell (Molasses Books, Brooklyn)"},
      { text: "2 mai 2025, 19h : Lectures et lancement pour The Hand of the Hand en groupe chez Ugly Duckling Presse (The Old American Can Factory, Gowanus)",
        url: "https://shop.uglyducklingpresse.org/products/udp-spring-studio-party-macaisa-colgate-nissan-abramovich-schluter-ulmer-rees"
      },
      { text: "1 mai 2025 : Parution de The Hand of the Hand, notre traduction de La Main de la main de Laura Vazquez, chez Ugly Duckling Presse"},
      { text: "26 avril 2025 : Rencontre Mnémosyne, discussion en anglais autour de l'hommage aux poètes, avec Shira Abramovich, Lénaïg Cariou, Carrie Chappell and Alison Koehler, Rerenga Wine, Paris, 14h30" },
      { text: "25 avril 2025 7pm: Rencontre autor d'Adrienne Rich avec Lénaïg Cariou, Shira Abramovich et Charlotte Blanchard à L’Affranchie (Lille)"},
      { text: "23 avril 2025 : Rencontre autour du Rêve d'un langage commun d'Adrienne Rich à la librairie La Friche, à Paris, mercredi 23 avril, 19h30, avec Shira Abramovich, Lénaïg Cariou, Alex Lachkar et Jeanne Bacharach" },
      { text: "15 mars 2025 : Rencontre autour d'Adrienne Rich, avec les éditions de L'Arche (Médiathèque de Saint-Quentin-en-Yvelines)" },
      { text: "18 mars 2025 : atelier \"Traduire le genre avec Adrienne Rich\" (ENS de Lyon)" },
      { text: "6 mars 2025 : Lancement de Printemps Rayon Elegie de Kay Gabriel, avec le collectif How to Become (Rerenga Wine, Paris)" },
      { text: "25 février 2025 : Book Club de France Culture autour d'Adrienne Rich" },
      { text: "Février 2025: Parution de Printemps Rayon Elégie. Sonnets pour Candy., notre traduction de Elegy Department Spring: Candy Sonnets 1 by Kay Gabriel, chez How to Become"},
      { text: "24 janvier 2025 : Nuit de la lecture : \"Nos matrimoines : écrivaines états-uniennes\", Librairie les Modernes, Grenoble"},
      { text: "22 janvier 2025 : Rencontre autour du Rêve d'un langage commun à la BU de l'Université Grenoble Alpes"},
      { text: '15 janvier 2025: Sortie du Rêve d\'un langage commun, notre traduction de The Dream of a Common Language d\'Adrienne Rich, chez L\'Arche Éditeur'},

      {
        text: "Lundi 6 novembre 2023 : Atelier de traduction avec Shira Abramovich à Simmons College"
      },
      {
        text: "Vendredi 13 octobre 2023 : Lecture avec Laura Vazquez au festival Les Inaccoutumes, presenté par La Ménagerie de Verre",
        url: "https://menageriedeverre.com/files/cp-inaccoutumes.pdf",
      },
      {
        text: "15 mai 2023: Atelier mené par Lénaïg Cariou au Centre Bloch Berlin sur le sujet « Traduire le genre avec Adrienne Rich »",
        url: "https://cmb.hu-berlin.de/en/calendar/event/elise-huchet-forum-marc-bloch-politiques-de-la-traduction",
      },
      {
        text: "Mars 2023: Interview avec le collectif Connexion Limitée / Limited Connection",
        url: "https://laviesansprincipe.wordpress.com/2023/03/08/interview-avec-le-collectif-connexion-limitee-limited-connection/",
      },
      {
        text: "Jeudi 30 mars 2023 - Lecture et entretien d'Eleni Sikelianos et Lénaïg Cariou au Festival Littérature au Centre, à Clermont-Ferrand",
      },
      {
        text: "Samedi 25 mars 2023, 18h30 - Lecture d'Eleni Sikelianos et de ses traductrices à la librairie EXC, à Paris",
      },
      {
        text: "Vendredi 27 janvier 2023, 20h - Soirée de lancement de Ce que j'ai connu d'Eleni Sikelianos à la librairie L'Atelier, à Paris: lecture et entretien avec les traductrices",
      },
      {
        text: "Automne 2022: Nos traductions de quatre poèmes de Laura Vazquez dans la revue Asymptote!",
        url: "https://www.asymptotejournal.com/poetry/the-hand-of-the-hand-laura-vazquez/",
      },
      {
        text: "19 Mars 2022: Camille Blanc et Lénaïg Cariou participent à une rencontre-lecture au Centre International de Poésie Marseille",
        url: "https://cipmarseille.fr/evenement_fiche.php?id=1459",
      },
      {
        text: "7 Avril 2021: Lénaïg Cariou organise la conférence « Femmes poètes, poètes femmes, poétesses… questions de terminologie » au Séminaire de l’Université de Chicago",
        url: "https://poetesses.hypotheses.org/",
      },
      {
        text: "Janvier 2021: Notre traduction de 'Brûler du papier plutôt que des enfants' d'Adrienne Rich dans la Revue Jef Klak",
        url: "https://www.jefklak.org/",
      },
      {
        text: "Décembre 2020: Notre traduction à contraintes de '$6.82' de Mónica de la Torre dans la Revue Fragile",
        url: "https://fragile-revue.fr/la-lettre/6-82/",
      },
    ],
  },
};

export default latestText;
